const GroupPermission = {
    AllGroup: [
        {
            name: "Quản lý tuyển sinh",
            isShow: true,
            hide: true,
            listPermission: [
                {
                    "isClick": true,
                    "isShow": true,
                    "name": "Báo cáo tuyển sinh",
                    "listPermission": [
                        {
                            "permission": "QLTS_CUSTOMER_REPORT",
                            "name": "Xem báo cáo",
                            "isShow": false,
                        }
                    ]
                },
                {
                    "isClick": true,
                    "isShow": true,
                    "name": "Quản lý khách hàng",
                    "listPermission": [
                        {
                            "permission": "QLTS_CUSTOMER_LIST",
                            "name": "Danh sách khách hàng",
                            "isShow": false,
                        },
                        {
                            "permission": "QLTS_CUSTOMER_ADD",
                            "name": "Thêm khách hàng",
                            "isShow": false,
                        },
                        {
                            "permission": "QLTS_CUSTOMER_DETAIL",
                            "name": "Chi tiết khách hàng",
                            "isShow": false,
                        },
                        {
                            "permission": "QLTS_CUSTOMER_EDIT",
                            "name": "Sửa khách hàng",
                            "isShow": false,
                        },
                        {
                            "permission": "QLTS_CUSTOMER_DELETE",
                            "name": "Xóa khách hàng",
                            "isShow": false,
                        },
                        {
                            "permission": "QLTS_CUSTOMER_SEARCH",
                            "name": "Tìm kiếm khách hàng",
                            "isShow": false,
                        },
                    ]
                },
                {
                    "isShow": true,
                    "isClick": true,
                    "name": "Quản lý nhóm khách hàng",
                    "listPermission": [
                        {
                            "permission": "QLTS_CUSTOMER_GROUP_LIST",
                            "name": "Danh sách nhóm khách hàng"
                        },
                        {
                            "permission": "QLTS_CUSTOMER_GROUP_DETAIL",
                            "name": "Chi tiết nhóm khách hàng"
                        },
                        {
                            "permission": "QLTS_CUSTOMER_GROUP_ADD",
                            "name": "Thêm nhóm khách hàng"
                        },
                        {
                            "permission": "QLTS_CUSTOMER_GROUP_EDIT",
                            "name": "Sửa nhóm khách hàng"
                        },
                        {
                            "permission": "QLTS_CUSTOMER_GROUP_DELETE",
                            "name": "Xóa nhóm khách hàng"
                        },
                        {
                            "permission": "QLTS_CUSTOMER_GROUP_SEARCH",
                            "name": "Tìm kiếm nhóm khách hàng"
                        },
                    ]
                },
                {
                    "isShow": true,
                    "isClick": true,
                    "name": "Quản lý chiến dịch tuyển sinh",
                    "listPermission":[
                        {
                            "permission": "QLTS_CAMPAIGN_LIST",
                            "name": "Danh sách chiến dịch tuyển sinh"
                        },
                        {
                            "permission": "QLTS_CAMPAIGN_ADD",
                            "name": "Thêm chiến dịch tuyển sinh"
                        },
                        {
                            "permission": "QLTS_CAMPAIGN_DETAIL",
                            "name": "Chi tiết chiến dịch tuyển sinh"
                        },
                        {
                            "permission": "QLTS_CAMPAIGN_EDIT",
                            "name": "Sửa chiến dịch tuyển sinh"
                        },
                        {
                            "permission": "QLTS_CAMPAIGN_DELETE",
                            "name": "Xóa chiến dịch tuyển sinh"
                        },
                        {
                            "permission": "QLTS_CAMPAIGN_SEARCH",
                            "name": "Tìm kiếm chiến dịch tuyển sinh"
                        },
                    ]
                }
            ]
        },
        {
            name: "Quản lý hệ thống",
            isShow: true,
            hide: true,
            listPermission: [
                {
                    "isShow": true,
                    "isClick": true,
                    "name": "Quản lý trường",
                    "listPermission": [
                        {
                            "permission": "SCHOOL_EDIT",
                            "name": "Cập nhật thông tin trường",
                            "isShow": true,
                        },
                        {
                            "permission": "SCHOOL_DETAIL",
                            "name": "Xem thông tin trường",
                            "isShow": true,
                        }
                    ]
                },
                {
                    "isShow": true,
                    "isClick": true,
                    "name": "Quản lý năm học",
                    "listPermission": [
                        {
                            "permission": "YEAR_LIST",
                            "name": "Danh sách năm học",
                            "isShow": true,
                        },
                        {
                            "permission": "YEAR_ADD",
                            "name": "Thêm năm học",
                            "isShow": true,
                        },
                        {
                            "permission": "YEAR_DETAIL",
                            "name": "Chi tiết năm học",
                            "isShow": true,
                        },
                        {
                            "permission": "YEAR_EDIT",
                            "name": "Sửa năm học",
                            "isShow": true,
                        },
                        {
                            "permission": "YEAR_DELETE",
                            "name": "Xóa năm học",
                            "isShow": true,
                        },
                        {
                            "permission": "YEAR_SEARCH",
                            "name": "Tìm kiếm năm học",
                            "isShow": true,
                        }
                    ]
                },
                {
                    "isShow": true,
                    "isClick": true,
                    "name": "Quản lý nhóm người dùng",
                    "listPermission": [
                        {
                            "permission": "GROUP_USER_LIST",
                            "name": "Danh sách nhóm người dùng",
                            "isShow": true,
                        },
                        {
                            "permission": "GROUP_USER_ADD",
                            "name": "Thêm nhóm người dùng",
                            "isShow": true,
                        },
                        {
                            "permission": "GROUP_USER_DETAIL",
                            "name": "Chi tiết nhóm người dùng",
                            "isShow": true,
                        },
                        {
                            "permission": "GROUP_USER_EDIT",
                            "name": "Sửa nhóm người dùng",
                            "isShow": true,
                        },
                        {
                            "permission": "GROUP_USER_DELETE",
                            "name": "Xóa nhóm người dùng",
                            "isShow": true,
                        },
                        {
                            "permission": "GROUP_USER_SEARCH",
                            "name": "Tìm kiếm nhóm người dùng",
                            "isShow": true,
                        }
                    ]
                },
                {
                    "isShow": true,
                    "isClick": true,
                    "name": "Quản lý người dùng",
                    "listPermission": [
                        {
                            "permission": "USER_LIST",
                            "name": "Danh sách người dùng",
                            "isShow": true,
                        },
                        {
                            "permission": "USER_ADD",
                            "name": "Thêm người dùng",
                            "isShow": true,
                        },
                        {
                            "permission": "USER_DETAIL",
                            "name": "Chi tiết người dùng",
                            "isShow": true,
                        },
                        {
                            "permission": "USER_EDIT",
                            "name": "Sửa người dùng",
                            "isShow": true,
                        },
                        {
                            "permission": "USER_DELETE",
                            "name": "Xóa người dùng",
                            "isShow": true,
                        },
                        {
                            "permission": "USER_SEARCH",
                            "name": "Tìm kiếm người dùng",
                            "isShow": true,
                        }
                    ]
                },
            ]
        }
    ],
    QLTS: [
        {
            "isShow": true,
            "name": "Quản lý khách hàng",
            "listPermission": [
                {
                    "permission": "QLTS_CUSTOMER_LIST",
                    "name": "Danh sách khách hàng",
                    "isShow": false,
                },
                {
                    "permission": "QLTS_CUSTOMER_ADD",
                    "name": "Thêm khách hàng",
                    "isShow": false,
                },
                {
                    "permission": "QLTS_CUSTOMER_DETAIL",
                    "name": "Chi tiết khách hàng",
                    "isShow": false,
                },
                {
                    "permission": "QLTS_CUSTOMER_EDIT",
                    "name": "Sửa khách hàng",
                    "isShow": false,
                },
                {
                    "permission": "QLTS_CUSTOMER_DELETE",
                    "name": "Xóa khách hàng",
                    "isShow": false,
                },
                {
                    "permission": "QLTS_CUSTOMER_SEARCH",
                    "name": "Tìm kiếm khách hàng",
                    "isShow": false,
                },
            ]
        },
        {
            "isShow": true,
            "name": "Quản lý nhóm khách hàng",
            "listPermission": [
                {
                    "permission": "QLTS_CUSTOMER_GROUP_LIST",
                    "name": "Danh sách nhóm khách hàng"
                },
                {
                    "permission": "QLTS_CUSTOMER_GROUP_DETAIL",
                    "name": "Chi tiết nhóm khách hàng"
                },
                {
                    "permission": "QLTS_CUSTOMER_GROUP_ADD",
                    "name": "Thêm nhóm khách hàng"
                },
                {
                    "permission": "QLTS_CUSTOMER_GROUP_EDIT",
                    "name": "Sửa nhóm khách hàng"
                },
                {
                    "permission": "QLTS_CUSTOMER_GROUP_DELETE",
                    "name": "Xóa nhóm khách hàng"
                },
                {
                    "permission": "QLTS_CUSTOMER_GROUP_SEARCH",
                    "name": "Tìm kiếm nhóm khách hàng"
                },
            ]
        },
        {
            "isShow": true,
            "name": "Quản lý chiến dịch tuyển sinh",
            "listPermission":[
                {
                    "permission": "QLTS_CAMPAIGN_LIST",
                    "name": "Danh sách chiến dịch tuyển sinh"
                },
                {
                    "permission": "QLTS_CAMPAIGN_ADD",
                    "name": "Thêm chiến dịch tuyển sinh"
                },
                {
                    "permission": "QLTS_CAMPAIGN_DETAIL",
                    "name": "Chi tiết chiến dịch tuyển sinh"
                },
                {
                    "permission": "QLTS_CAMPAIGN_EDIT",
                    "name": "Sửa chiến dịch tuyển sinh"
                },
                {
                    "permission": "QLTS_CAMPAIGN_DELETE",
                    "name": "Xóa chiến dịch tuyển sinh"
                },
                {
                    "permission": "QLTS_CAMPAIGN_SEARCH",
                    "name": "Tìm kiếm chiến dịch tuyển sinh"
                },
            ]
        }
    ],
    SYSTEM: [
        {
            "name": "Quản lý trường",
            "listPermission": [
                {
                    "permission": "SCHOOL_LIST",
                    "name": "Danh sách trường"
                },
                {
                    "permission": "SCHOOL_ADD",
                    "name": "Thêm trường"
                },
                {
                    "permission": "SCHOOL_DELETE",
                    "name": "Xóa trường"
                },
                {
                    "permission": "SCHOOL_EDIT",
                    "name": "Sửa trường"
                },
                {
                    "permission": "SCHOOL_DETAIL",
                    "name": "Xem chi tiết trường"
                }
            ]
        },
        {
            "name": "Quản lý năm học",
            "listPermission": [
                {
                    "permission": "YEAR_LIST",
                    "name": "Danh sách năm học"
                },
                {
                    "permission": "YEAR_ADD",
                    "name": "Thêm năm học"
                },
                {
                    "permission": "YEAR_DETAIL",
                    "name": "Chi tiết năm học"
                },
                {
                    "permission": "YEAR_EDIT",
                    "name": "Sửa năm học"
                },
                {
                    "permission": "YEAR_DELETE",
                    "name": "Xóa năm học"
                },
                {
                    "permission": "YEAR_SEARCH",
                    "name": "Tìm kiếm năm học"
                }
            ]
        },
        {
            "name": "Quản lý nhóm người dùng",
            "listPermission": [
                {
                    "permission": "GROUP_USER_LIST",
                    "name": "Danh sách nhóm người dùng"
                },
                {
                    "permission": "GROUP_USER_ADD",
                    "name": "Thêm nhóm người dùng"
                },
                {
                    "permission": "GROUP_USER_DETAIL",
                    "name": "Chi tiết nhóm người dùng"
                },
                {
                    "permission": "GROUP_USER_EDIT",
                    "name": "Sửa nhóm người dùng"
                },
                {
                    "permission": "GROUP_USER_DELETE",
                    "name": "Xóa nhóm người dùng"
                },
                {
                    "permission": "GROUP_USER_SEARCH",
                    "name": "Tìm kiếm nhóm người dùng"
                }
            ]
        },
        {
            "name": "Quản lý người dùng",
            "listPermission": [
                {
                    "permission": "USER_LIST",
                    "name": "Danh sách người dùng"
                },
                {
                    "permission": "USER_ADD",
                    "name": "Thêm người dùng"
                },
                {
                    "permission": "USER_DETAIL",
                    "name": "Chi tiết người dùng"
                },
                {
                    "permission": "USER_EDIT",
                    "name": "Sửa người dùng"
                },
                {
                    "permission": "USER_DELETE",
                    "name": "Xóa người dùng"
                },
                {
                    "permission": "USER_SEARCH",
                    "name": "Tìm kiếm người dùng"
                }
            ]
        },
    ],

}

export default GroupPermission


